// PostHog analytics manager
import posthog from "posthog-js";

let posthogClient = null;

export const initializePostHog = () => {
  try {
    // Only initialize in production environment
    if (!posthogClient && process.env.REACT_APP_ENVIRONMENT === "production") {
      // Initialize PostHog with your configuration
      posthog.init(
        process.env.GATSBY_PUBLIC_POSTHOG_KEY,
        {
          api_host: process.env.GATSBY_PUBLIC_POSTHOG_HOST || "https://app.posthog.com",
          autocapture: true,
          capture_pageview: true,
          loaded: (phInstance) => {
            posthogClient = phInstance;
          }
        }
      );
    } else if (process.env.REACT_APP_ENVIRONMENT !== "production") {
      console.log("PostHog not initialized: non-production environment");
    }
    return posthogClient;
  } catch (error) {
    console.error("Error initializing PostHog:", error);
    return null;
  }
};

export const resetPostHog = () => {
  if (posthogClient) {
    posthogClient.opt_out_capturing();
    posthogClient = null;
  }
};